export default "__VITE_ASSET__DLz9SkkB__"